import React from 'react';
import { Link } from 'gatsby';
import { Box, Container, Grid, useTheme } from '@mui/material';
import { globalMenus } from 'models/menu';
import DrawerMenu from './DrawerMenu';

const Header = () => {
  const { spacing, palette, breakpoints, typography } = useTheme();

  return (
    <Container
      component="header"
      sx={{
        position: 'fixed',
        backgroundColor: 'rgba(250, 248, 245, 0.85)',
        width: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 300,
        backdropFilter: 'blur(3px)',
        paddingTop: spacing(1),
        height: 48,
      }}
    >
      <Box position="relative" height="100%" display="flex">
        <Grid
          container
          alignItems="center"
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Grid>
            <Box
              component="span"
              sx={{
                [breakpoints.up('md')]: {
                  display: 'none',
                },
              }}
            >
              <DrawerMenu />
            </Box>
          </Grid>
          <Grid
            component="ul"
            alignItems="center"
            xs={4}
            container
            sx={{
              [breakpoints.down('sm')]: {
                display: 'none',
              },
              margin: 0,
              padding: 0,
              justifyContent: 'flex-end',
              fontSize: typography.body2.fontSize,
              '& li': {
                margin: 0,
                listStyle: 'none',
                marginRight: spacing(3),
              },
              '& a': {
                textDecoration: 'none',
                color: 'inherit',
                '&.active': {
                  color: palette.primary.main,
                },
                '&:hover': {
                  textDecoration: 'underline',
                },
                '&:visited': {
                  color: 'inherit',
                },
              },
            }}
          >
            {globalMenus.map(menu => (
              <Grid component="li" item key={menu.path}>
                <Link to={menu.path}>{menu.name}</Link>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Header;
